import { useEffect, useState } from "react";
import { ReactNode } from "react";
import { Layout as SharedLayout } from "antd";
import { Siderbar } from "./sidebar/Siderbar";
import LayoutHeader from "./header/LayoutHeader";
import LayoutContent from "./content/LayoutContent";
import { useAppLayout } from "@dataone/lib";
import { useAuth } from "../features/auth/contexts/auth.provider";

export const Layout = ({ children }: { children: ReactNode }) => {
  const initCollapsedValue = useAppLayout.getState().collapsed;

  const [collapsed, setCollapsed] = useState(initCollapsedValue);

  const { isAuthenticated, user } = useAuth();

  useEffect(
    () =>
      useAppLayout.subscribe((state) => {
        setCollapsed(state.collapsed);
      }),
    []
  );

  return (
    <SharedLayout>
      {!(!isAuthenticated && !user) && <Siderbar collapsed={collapsed} />}
      <SharedLayout>
        <LayoutHeader />
        <LayoutContent>{children}</LayoutContent>
      </SharedLayout>
    </SharedLayout>
  );
};
